import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { axiosapi } from '../api/axiosapi'
import jwt_decode from "jwt-decode";
import { addUserDetailsToState } from '../redux/ActionCreators'

const PersistLogin = (props) => {

    const dispatch = useDispatch()

    useEffect(() => {
        const verifyRefreshToken = async () => {
            try {

                const response = await axiosapi.get('/auth/refresh', { headers: { 'Content-type': 'application/json' }, withCredentials: true });

                let decoded = jwt_decode(response.data.accessToken);
                const userInfo = {
                    email: decoded.email,
                    name: decoded.name,
                    id: decoded.id,
                    accessToken: response.data.accessToken,
                    userRoles: decoded.userRoles
                }
                console.log("Inside Persist login", userInfo)

                dispatch(addUserDetailsToState(userInfo));

            }
            catch (err) {
                console.error(err);
            }
        }


        // persist added here AFTER tutorial video
        // Avoids unwanted call to verifyRefreshToken
        console.log(props.user?.userinfo);
        if (props.user?.persist && props.user?.userinfo === null) {
            console.log("hello")
            verifyRefreshToken()
        }



    }, [])

    return (
        <> {!props.user?.persist ? <Outlet /> :
            props.user?.userinfo !== null ? <Outlet /> : <></>
        }
        </>

    )
}

export default PersistLogin
